export default __webpack_public_path__ + "6e1d79a421718806a69c0b49f41802bb.jpg";